// extracted by extract-css-chunks-webpack-plugin
module.exports = {"bermuda-triangle":"bermuda-triangle","postcard__envelope":"postcard__envelope","postcard__wrapper":"postcard__wrapper","postcard":"postcard"};